import { useMemo } from "react";
import { tss } from "tss-react/mui";
import { AgGridReact } from "ag-grid-react";
import { panelBackgroundColor } from "styles/common";
import { Palette } from "@mui/icons-material";

const useStyles = tss.create(({ theme }) => ({
    scroll: {
        height: "100%",
        width: "100%",
        "& ::-webkit-scrollbar": {
            width: 6,
            height: 6,
        },
        "& ::-webkit-scrollbar-track": {
            "WebkitBoxShadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 3,
        },
        "& ::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            borderRadius: 3,
        },
    },
    myClassAppliedToGrid: {
        "& .ag-root": {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
        },
        "& .ag-header": {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderColor: theme.palette.divider
        },
        "& .ag-header-cell": {
            color: theme.palette.text.primary,
            "&:hover": {
                backgroundColor: "inherit !important"
            }
        },
        "& .ag-row": {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderColor: theme.palette.divider,
            "& svg": {
                color: theme.palette.text.primary,
                fill: theme.palette.text.primary,
                "& path": {
                    stroke: theme.palette.text.primary,
                }
            }
        },
    },
}));

export default function DataGrid(props: { rows: any; columns: any; maxWidth?: any; maxHeight?: any }) {
    const { rows, columns, maxWidth, maxHeight } = props;
    const { classes } = useStyles();

    const containerStyle = useMemo(
        () => ({ width: "100%", height: "100%", maxWidth: maxWidth, maxHeight: maxHeight }),
        [maxWidth, maxHeight]
    );
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

    return (
        <div className={classes.scroll} style={containerStyle}>
            <div style={gridStyle} className="ag-theme-alpine">
                <AgGridReact 
                    rowData={rows} 
                    columnDefs={columns} 
                    className={classes.myClassAppliedToGrid}
                    suppressRowHoverHighlight={true}
                    columnHoverHighlight={false}
                >

                </AgGridReact>
            </div>
        </div>
    );
}
